module.exports = "/static/assets/01be678cc22033db268c55584b4b1145.png";